import { Configuration, PopupRequest, PublicClientApplication } from '@azure/msal-browser';
import { reactApp } from '../../util/constants/common.constants'

// Config object to be passed to Msal on creation

export const msalConfig: Configuration = {
  auth: {
    clientId: reactApp().clientId,
    authority: `https://login.microsoftonline.com/${reactApp().tenantId}`,
    redirectUri: reactApp().redirectUri ? reactApp().redirectUri : reactApp().apiUrl,
    postLogoutRedirectUri: '/',
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  //scopes: [`openid api://${reactApp().clientId}/Loc.Access`],
  scopes: [`openid api://cac177a0-134d-44c5-b4c5-f0f9d63478cd/.default`],
  // scopes: ["User.Read"],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};

export const msalInstance = new PublicClientApplication(msalConfig);
